import axios from 'axios';

// API根路径配置
const isDevelopment = process.env.NODE_ENV === 'development';
const API_BASE_URL = isDevelopment 
  ? 'http://localhost:8080/api' 
  : 'https://guessing.paipai.xinjiaxianglao.com/api';

interface SpeechToTextResponse {
  text: string;
  filePath?: string;
  fileName?: string;
}

export const speechToText = async (audioFile: File | Blob): Promise<SpeechToTextResponse> => {
  const formData = new FormData();
  formData.append('audio', audioFile);

  try {
    const response = await axios.post(`${API_BASE_URL}/speech-to-text`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error('Speech to text error:', error);
    throw new Error('语音识别失败');
  }
};

export const checkAnswer = async (answer: string, riddleId: string): Promise<number> => {
  try {
    const response = await axios.post(`${API_BASE_URL}/check-answer`, {
      answer,
      riddleId,
    });
    return response.data.score;
  } catch (error) {
    console.error('Check answer error:', error);
    throw new Error('答案验证失败');
  }
}; 